import { PoolAccordionDetails } from '@synergy/components-next';
import { styled } from '@mui/material';

export const FilterAccordionDetails = styled(PoolAccordionDetails)(({ theme }) => ({
    padding: 0,
    margin: 0,
    marginBottom: theme.spacing(),
}));
